import { posts } from '../data/posts.js';
import { request } from './httpClient.js';

export async function getPosts() {
  if (import.meta.env.VITE_API_BASE_URL) {
    return request('/posts');
  }

  return posts;
}
